import { generateEventTable } from './js_module/utils/generateEventTable.js';
import {
  handleUserLoginStatus,
  isLoggedIn,
} from './js_module/user/isLoggedIn.js';
import { fetchEventData } from './js_module/fetch/fetchEventData.js';
import { monitorXHR } from './js_module/interceptions/xhr-monitor.js';
import sessionStorageModule from './js_module/utils/sessionStorageModule.js';
import {
  couponTestClickEventHandler,
} from './js_module/coupons/couponTestClickEventHandler.js';
import {
  changeOrderQuantityHandler,
} from './js_module/order/changeOrderQuantityHandler.js';
import {
  closeAndClearCheckout,
} from './js_module/utils/closeAndClearCheckout.js';
import { fetchEventsFromPage } from './js_module/fetch/fetchEventsFromPage.js';
import {
  fetchEventBucketConfig,
} from './js_module/settings_config/fetchEventBucketConfig.js';
import { updateEventButtons } from './js_module/utils/eventButtonsStauts.js';
import {
  displayUserSelfTickets,
} from './js_module/user/displayUserSelfTickets.js';
import { fetchSelfPasses } from './js_module/fetch/fetchSelfPasses.js';
import {
  getApplicablePassesForEvent,
} from './js_module/passes/userSelfPassesHandler.js';
import {
  showPassSelectionOverlay,
} from './js_module/passes/showPassSelectionOverlay.js';
import { getUserToken } from './js_module/user/getUserToken.js';
import {
  generateEventPassTable,
} from './js_module/utils/generateEventPassTable.js';
import {
  createAndUpdateOrder,
} from './js_module/order/createAndUpdateOrder.js';
import { setSubTotalPrices } from './js_module/utils/setSubTotalPrices.js';
import { calculateGrandTotal } from './js_module/utils/calculateGrandTotal.js';
import {
  uiUpdateByNowAndOrderButton,
} from './js_module/payment/uiUpdateByNowAndOrderButton.js';
import {
  submitBuyNowAndOrderButton,
} from './js_module/payment/submitBuyNowAndOrderButton.js';

import { eventData } from './js_module/helper/EventData.js';
import { eventPass } from './js_module/helper/EventPass.js';
import { eventBucketConfig } from './js_module/helper/EventBucketConfig.js';



(function ($, Drupal, drupalSettings, once) {
  'use strict';

  let loginButton, eventModal, overlay, userToken;
  /** @type {AvailableEvents} */
  let availableEvents = {
    events: [],
  };
  /** @type {UserGlobalPasses} */
  let userGlobalPasses = {};
  let userData = {
    isUserLoggedIn: false,
    user: {},
    token: '',
  };

  const privatApiKey = drupalSettings.eventive_api.live_private_api_key;
  const apiBaseUrl = drupalSettings.eventive_api.eventive_api_url;
  const eventBucketId = drupalSettings.eventive_api.event_bucket_id;
  const eventBucketUrl = drupalSettings.eventive_api.event_bucket_url;

  document.addEventListener('onTokenUpdate', async function (e) {
    const userData = e.detail.userData;
    sessionStorageModule.setItem('gd-checkout-data', userData);
    try {
      let gdCheckoutData = sessionStorageModule.getItem('gd-checkout-data');
      if (gdCheckoutData && gdCheckoutData.token) {
        gdCheckoutData = {
          ...gdCheckoutData,
          isUserLoggedIn: true,
        };
        sessionStorageModule.setItem('gd-checkout-data', gdCheckoutData);
        userToken = getUserToken();
        await displayUserSelfTickets(eventBucketId, privatApiKey, userToken);
        userGlobalPasses = await fetchSelfPasses(userToken, eventBucketId, privatApiKey);
      }
    } catch (error) {
      console.error('Error fetching tickets:', error);
    }
  });

  function attachEventListeners(paypalEventButtons, errorDetails) {
    paypalEventButtons.forEach(button => {
      button.addEventListener('click', async function () {
        try {
          const eventId = this.getAttribute('data-eventid');

          // Benutzerdaten prüfen und speichern
          const user = await isLoggedIn();
          userData = handleUserLoginStatus(user, userToken);
          // Event-Data load.
          const eventDataResult = await fetchEventData(eventId, apiBaseUrl, privatApiKey, userToken);
          eventData.set(eventDataResult);

          const userEventPasses = eventDataResult?.person?.passes || [];
          if (userData?.isUserLoggedIn && userGlobalPasses && Object.keys(userGlobalPasses).length > 0 && userGlobalPasses.passes.length > 0) {
            const applicablePassesForEvent = getApplicablePassesForEvent(userGlobalPasses, eventDataResult);
            await showPassSelectionOverlay(applicablePassesForEvent, userEventPasses, async (pass) => {
              // console.trace({'Pass selected eventPass: ': eventPass});
              eventPass.set(pass);
              // selectedEventPass = eventPass.get();
              const eventDataResult = await fetchEventData(eventId, apiBaseUrl, privatApiKey, userToken);
              eventData.set(eventDataResult);
              generateEventPassTable(eventPass.get());
              const order = await createAndUpdateOrder(privatApiKey, eventBucketId, userData, eventPass.get());
              setSubTotalPrices(order);
              calculateGrandTotal(order);
              uiUpdateByNowAndOrderButton(order);
              eventModal.style.display = 'block';
            }, () => {
              // console.trace('Continue without pass, button click.');
              openCheckoutOverlay();
            });
          } else {
            // No valid pass, normal checkout.
            await openCheckoutOverlay();
          }
          submitBuyNowAndOrderButton(privatApiKey, eventBucketId);
        } catch (error) {
          errorDetails.innerHTML = `<h2 class="error_text">${Drupal.t('Event data could not be loaded.')}</h2>
                <p class="error_text">${Drupal.t('Sorry, we cannot load the data. Either an error has occurred or there was a delay in loading the data. Please try again. If it still doesn\'t work, please send us a message. Thank you for your understanding!')}</p>`;
          console.error('Error fetching event data or processing order:', error);
        }

      });

    });
    window.changeQuantity = async (bucketId, delta, price) => {
      await changeOrderQuantityHandler(bucketId, delta, price, privatApiKey, eventBucketId, eventPass.get());
    };

  }

  /**
   * Opens the checkout overlay.
   */
  async function openCheckoutOverlay() {
    eventModal.style.display = 'block';
    // generate Table with current Event data.
    generateEventTable();
    // click handler button apply coupon in event modal.
    await couponTestClickEventHandler(privatApiKey, eventBucketId);
  }



  Drupal.behaviors.eventiveApi = {
    attach: function (context, settings) {
      const paypalEventButtons = once('paypalCheckout', '.paypal_checkout', context);
      if (paypalEventButtons.length <= 0) {
        return;
      }

      eventModal = document.getElementById('gd__checkout__container');
      loginButton = document.querySelector('#gd__checkout__login__button .eventive-login');
      overlay = document.getElementById('gd__checkout__overlay');
      const errorDetails = document.getElementById('gd__checkout__global__error');
      /** @type {DrupalEventiveSettings} settings */
      // if any required settings not exist log error in console
      if (!settings?.eventive_api || !settings.eventive_api?.live_private_api_key || !settings.eventive_api?.eventive_api_url || !settings.eventive_api.create_order_route || !settings?.eventive_api?.event_bucket_id || !settings?.eventive_api?.event_bucket_url) {
        console.trace('Eventive API settings not available.');
        return;
      }

      (async function initialize() {
        try {
          /** @type {EventBucketConfig | null} eventBucketConfigPayLoad */
          const eventBucketConfigPayLoad = await fetchEventBucketConfig(eventBucketUrl);
          eventBucketConfig.set(eventBucketConfigPayLoad);
          availableEvents = await fetchEventsFromPage(privatApiKey, eventBucketId);
          if (availableEvents) {
            userToken = getUserToken();
            userGlobalPasses = await fetchSelfPasses(userToken, eventBucketId, privatApiKey);
            updateEventButtons(availableEvents, eventBucketConfig.get());
          }
          // Now everything is loaded, activate the event listener.
          attachEventListeners(paypalEventButtons, errorDetails);
          await displayUserSelfTickets(eventBucketId, privatApiKey, userToken);

        } catch (error) {
          console.error('Error initializing event data:', error);
        }
      })();

      monitorXHR();

      closeAndClearCheckout();
    },
  };

})(jQuery, Drupal, drupalSettings, once);
